import styles from "./styles.module.scss"
import cn from "clsx"
import type { FC, HTMLAttributes } from "react"


interface WrapperProps
extends HTMLAttributes<HTMLDivElement> {
  double?: boolean,
  limitedWidth?: boolean,
}

export const Wrapper: FC<WrapperProps> = ({ 
  className, double, limitedWidth = true,
  ...rest 
}) => (
  <div {...rest} className={cn(styles.wrapper, className, {
    [styles.double]: double,
    [styles.limited]: limitedWidth,
  })} />
)
